module.exports = __webpack_public_path__ + "static/media/calendar.3a046f23.png";